module.exports = __webpack_public_path__ + "img/1489372037.a7d50f61.jpg";